import React, {useEffect, useRef, useState} from 'react';
import {setupIonicReact, IonApp, IonRouterOutlet} from '@ionic/react';
import '@ionic/react/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/react/css/normalize.css';
import '@ionic/react/css/structure.css';
import '@ionic/react/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/react/css/padding.css';
import '@ionic/react/css/float-elements.css';
import '@ionic/react/css/text-alignment.css';
import '@ionic/react/css/text-transformation.css';
import '@ionic/react/css/flex-utils.css';
import '@ionic/react/css/display.css';

/* Theme variables */
import './theme/variables.css';
import './theme/common-style.css';
import './theme/common-responsive-desktop.css';
import './theme/common-responsive-mobile.css';
import { PushNotifications } from '@capacitor/push-notifications';
import {actionToGetUserSessionData} from "./apiHelpers/CommonAction";
import {IonReactRouter} from "@ionic/react-router";
import {Redirect, Route} from "react-router";
import LoginPage from "./pages/LoginPage";
import DashboardPage from "./pages/DashboardPage";
import RegisterPage from "./pages/RegisterPage";
import ForgotPassword from "./pages/ForgotPassword";
import {Capacitor} from "@capacitor/core";
import {NavigationBar} from "@mauricewegner/capacitor-navigation-bar";
import {StatusBar, Style} from "@capacitor/status-bar";
import appLogo from "./theme/images/site-small-logo-no-bg.png";
import AdminDashboardPage from "./pages/Admin/AdminDashboardPage";
import useStore from "./zustand/useStore";
import PolicyWithoutLogin from "./pages/PolicyWithoutLogin";
import HeaderWithoutLoginComponent from "./components/HeaderWithoutLoginComponent";
import WithoutLoginLeftSideMenuComponent from "./components/WithoutLoginLeftSideMenuComponent";
import DeactivateAccountPage from "./pages/DeactivateAccountPage";
import ContactUsPage from "./pages/ContactUsPage";
import AboutUsPage from "./pages/AboutUsPage";
import MembershipMobilePage from "./pages/MembershipMobilePage";
import MembershipDesktopPage from "./pages/MembershipDesktopPage";
import FcmTokenRegistrarNative from "./components/FcmTokenRegistrarNative";

setupIonicReact();

const AppEnterMainPage = ({userInfo,isMobile}) => {
    const handleClick = () => {
        window.open("https://wa.me/9711310004", "_blank");
    };


    return (
        <>
            {(userInfo?.role === 1) ?
                <IonReactRouter>
                    <IonRouterOutlet>
                        <Route path="/dashboard/*" component={AdminDashboardPage}/>
                        <Route path="/policy" exact={true} component={PolicyWithoutLogin} />
                        <Redirect exact from="/"  to="/dashboard/" />
                        <Route render={() => <Redirect to="/dashboard/" />} />
                    </IonRouterOutlet>
                </IonReactRouter>
                :
                <IonReactRouter>
                    <IonRouterOutlet>
                        <Route path="/dashboard/*" component={DashboardPage}/>
                        <Route path="/policy" exact={true} component={PolicyWithoutLogin} />
                        <Redirect  exact from="/"  to="/dashboard/" />
                        <Route render={() => <Redirect to="/dashboard/" />} />
                    </IonRouterOutlet>
                </IonReactRouter>
            }
            {/*//////// WHATSAPP BUTTON /////////*/}
            {(userInfo?.role !== 1 && isMobile) && (
                <button onClick={handleClick} className={"whatsapp_floating_button"}>
                    <svg xmlns="http://www.w3.org/2000/svg" aria-label="WhatsApp" role="img" viewBox="0 0 512 512">
                        <rect width="512" height="512" rx="15%" fill="#25d366"/>
                        <path fill="#25d366" stroke="#ffffff" strokeWidth="26"
                              d="M123 393l14-65a138 138 0 1150 47z"/>
                        <path fill="#ffffff"
                              d="M308 273c-3-2-6-3-9 1l-12 16c-3 2-5 3-9 1-15-8-36-17-54-47-1-4 1-6 3-8l9-14c2-2 1-4 0-6l-12-29c-3-8-6-7-9-7h-8c-2 0-6 1-10 5-22 22-13 53 3 73 3 4 23 40 66 59 32 14 39 12 48 10 11-1 22-10 27-19 1-3 6-16 2-18"/>
                    </svg>
                </button>

            )}
            {/*//////// WHATSAPP BUTTON /////////*/}
        </>
    );
}

const PublicRoutes = ({isMobile}) => {
    const menuRef = useRef(null);
    const [currentPath,setCurrentPath] = useState('/dashboard/home')
    const {menuOpen, setMenuOpen} = useStore();

    const renderHeaderPage = (panelSubHeader = null) => (
        <HeaderWithoutLoginComponent
            menuRef={menuRef}
            currentPath={currentPath}
            menuOpen={menuOpen}
            setMenuOpen={setMenuOpen}
            isMobile={isMobile}
            panelSubHeader={panelSubHeader}
            setCurrentPath={setCurrentPath}
            menuId="login-main-menu"
        />
    );

    return (
        <IonReactRouter>
            {/*///////// LEFT SIDE MOBILE MENU /////////*/}
            <WithoutLoginLeftSideMenuComponent
                menuOpen={menuOpen}
                setMenuOpen={setMenuOpen}
                isMobile={isMobile}
                setCurrentPath={setCurrentPath}
                menuRef={menuRef}
                menuId="login-main-menu"
                pageId="login-main-menu-content"/>
            {/*///////// LEFT SIDE MOBILE MENU /////////*/}
            <IonRouterOutlet id={"login-main-menu-content"}>
                <Route path="/login" exact={true} render={()=>(<LoginPage renderHeaderPage={renderHeaderPage}/>)} />
                <Route path="/signup" exact={true} render={()=>(<RegisterPage renderHeaderPage={renderHeaderPage}/>)} />
                <Route path="/policy" exact={true} render={()=>(<PolicyWithoutLogin renderHeaderPage={renderHeaderPage}/>)} />
                <Route path="/deactivate" exact={true} render={()=>(<DeactivateAccountPage withoutLogin={true} renderHeaderPage={renderHeaderPage}/>)} />
                <Route path="/contact-us" exact={true} render={()=>(<ContactUsPage renderHeaderPage={renderHeaderPage}/>)} />
                <Route path="/about-us" exact={true} render={()=>(<AboutUsPage renderHeaderPage={renderHeaderPage}/>)} />
                <Route exact path="/membership" render={()=>(
                    <>
                        {(isMobile) ?
                            <MembershipMobilePage withoutLogin={true} renderHeaderPage={renderHeaderPage}/>
                            :
                            <MembershipDesktopPage withoutLogin={true} renderHeaderPage={renderHeaderPage}/>
                        }
                    </>
                )} />
                <Route path="/forgot-password" exact={true} render={()=>(<ForgotPassword renderHeaderPage={renderHeaderPage}/>)} />
                <Redirect exact from="/"  to="/login" />
                <Route render={() => <Redirect to="/login" />} />
            </IonRouterOutlet>
        </IonReactRouter>
    );
};

const App = () => {
    const {userSession,userAuthDetail} = useStore();
    const [isMobile, setIsMobile] = useState(window.innerWidth < 1000);


    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 1000);
            if(document.querySelector('.mobile-contain-feed-events')){
                let leftSide = document.querySelector('.mobile-contain-feed-events')?.getBoundingClientRect()?.left;
                if(leftSide){
                    document.documentElement.style.setProperty('--event-page-left-side', `${leftSide}px`);
                }
            }
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);


    const callFunctionToGetSession = ()=>{
        actionToGetUserSessionData();
    }

    useEffect(() => {
        callFunctionToGetSession();
    }, []);

    useEffect(()=>{
        if(Capacitor.isNativePlatform()){
            if(Capacitor.getPlatform() !== 'ios'){
                NavigationBar.setColor({ color: '#ffffff' , darkButtons:true});
                StatusBar.setBackgroundColor({ color: '#ffffff' }).then(()=>{
                    StatusBar.setStyle({ style:Style.Light });
                });
            }
            PushNotifications.requestPermissions();
        }
    },[])

    useEffect(() => {
        // Only apply for web builds
        if (!Capacitor.isNativePlatform()) {
            if (isMobile) {
                // 🌐 Web (Mobile) — compact font scale
                document.documentElement.style.setProperty('--font-size-1', `1.125rem`); // ~18px
                document.documentElement.style.setProperty('--font-size-2', `1rem`);     // ~16px
                document.documentElement.style.setProperty('--font-size-3', `0.875rem`); // ~14px
                document.documentElement.style.setProperty('--font-size-4', `0.75rem`);  // ~12px
                document.documentElement.style.setProperty('--font-size-5', `0.625rem`); // ~10px
                document.documentElement.style.setProperty('--font-size-6', `0.5rem`);   // ~8px
                document.documentElement.style.setProperty('--font-size-7', `0.375rem`); // ~6px
            }
        }
    }, [isMobile]);

    return (
        <IonApp>
            {(!userSession?.loading) ?
                <React.Fragment>
                    {userAuthDetail?.userInfo?.id ?
                        <AppEnterMainPage userInfo={userAuthDetail?.userInfo} isMobile={isMobile}/>
                        :
                        <PublicRoutes isMobile={isMobile}/>
                    }
                </React.Fragment>
                :
                <div className={"splash_loading_screen"}>
                    <div className={"splash_loading_screen_inner"}>
                        <img alt={'logo'} src={appLogo}/>
                    </div>
                </div>
            }
            <FcmTokenRegistrarNative/>
        </IonApp>
    );
}
export default App;